import { BaseApiService } from "../base/base-api.service";
import { DocumentTypeDTO, DocumentTypeSTO } from "../../models/document-types";
import { ListSortDirection, Sort } from "../../models/api/sort";
import { SaveResponse } from "../../models/api/save/save.response";

import { toastifyResponse } from "../../utils/toastify-response/toastify-response";
import { PropsFilter } from "../../models/api/props-filter/props-filter";

export class DocumentTypesApiService extends BaseApiService<DocumentTypeDTO, DocumentTypeSTO> {
  constructor() {
    super({
      servicePath: "/DocumentTypes",
      loadItemsPath: "/GetDocumentTypes",
      saveItemsPath: "/SaveDocumentTypes",
    });
    this.defaultSort = [
      {
        name: "sequence",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}

export const loadDocumentType = async (id?: string) => {
  const response = await new DocumentTypesApiService().loadItems({
    requiredTransactionTypes: [id as string],
  } as PropsFilter);

  toastifyResponse(response, "failed");

  return response;
};

export const saveDocumentType = async (documentType: DocumentTypeSTO): Promise<SaveResponse> => {
  const response = await new DocumentTypesApiService().saveItems([documentType]);

  toastifyResponse(response);

  return response;
};
